import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';


const allUrl = 'volunteer/get?';
const eachUrl = 'volunteer/getEach?';
const trainingUrl = 'volunteer/trainings/get?';


const state = {
  volunteers: [],
  volunteer: {},
  trainingData: [],
};
const getters = {};
const mutations = {
  SET_VOLUNTEERS(state, payload) {
    state.volunteers = payload.data.data
  },
  SET_VOLUNTEER(state, payload) {
    state.volunteer = payload.data.data
  },
  SET_TRAINING_DATA(state, payload) {
    state.trainingData = payload.data.data;
  },
};

const actions = {
  async getVolunteers({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit('SET_VOLUNTEERS', response)
  },
  async getVolunteer({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_VOLUNTEER", response);

  },
  async getVolunteerByTwnId({ commit }, id) {
    const response = await Request.get_data(allUrl, { township_id: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit('SET_VOLUNTEERS', response)
  },
  async getVolunteerTraining({ commit }, id) {
    const response = await Request.get_data(trainingUrl, { volunteer_id: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TRAINING_DATA", response);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
